@use '@/styles/tokens' as *;

.bodyReset {
  padding: 0 !important;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.drawer :global(.ant-drawer-content) {
  background: var(--surface-card);
  box-shadow: var(--shadow-overlay);
}

@media (prefers-reduced-motion: reduce) {
  .drawer :global(.ant-drawer-content-wrapper),
  .drawer :global(.ant-drawer-mask) {
    transition-duration: 0.001ms !important;
  }
}

// A drawer stacked over another drawer: one scrim, not two. The mask element stays — it is the
// outside-click target that closes the top drawer without touching the one below it. Scoped
// through the root class, the same way the reduced-motion rule above reaches the mask.
.stacked :global(.ant-drawer-mask) {
  background: transparent;
}
